import HeaderSubPages from "../components/HeaderSubPages";
import '../assets/css/Progress.css'
import IGFeed from "../components/IGFeed";
import data from "../data/progress-lookout.json"


function ProgressLookout() {
  return (
    <div className="progress">
      <div className="progress-header-lookout">
        <HeaderSubPages />
      </div>
      <div className="progress-subheader">
        <h2>Lookout and Christmas Lift Replacement Project Progress</h2>
        <div className="main-text">
          <p>Coming winter 2026-2027, the Lookout Express and Christmas Lift replacements will increase reliability and uphill capacity while continuing the modernization of Sun Valley's lift infrastructure.</p>
          <p>Check out the updates below to watch every stage of the project.</p>
        </div>
      </div>

      <div className="progress-container">
        <div className="progress-line"></div>

        {data.map((dataItem, index) => (
          <div className="update-container" key={index}>
            <h4>{dataItem.date}</h4>
            <div className="progress-line-bullet"></div>
            <div className="update-text">
              <h3>{dataItem.title}</h3>
              <p>{dataItem.text}</p>
            </div>
            <div className="update-video">
              <iframe src={dataItem.media} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
          </div>
        ))}

      </div>
      <div className="ig-feed-progress">
        <div className="igfeed-progress-title">
          <h4>Keep Up to Date with @sunvalley</h4>
        </div>
        <IGFeed />
      </div>
    </div>
  );
}

export default ProgressLookout;